import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { NavLink } from 'fluxible-router';
import config from 'config/config';
import Notification from '../../common/notification';

class SecondaryNavigation extends Component {
  static displayName = 'SecondaryNavigation';

  static propTypes = {
    menuItems: PropTypes.array,
    selected: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string
  };

  static defaultProps = {
    menuItems: [],
    style: {}
  };

  render() {
    const { style } = this.props;
    var menuItems = [];
    this.props.menuItems.forEach((item, index) => {
      const selected = this.props.selected.indexOf(item.routeName) > -1;
      let linkClassName = classnames('secondary-item', {
        selected,
        'has-dropdown': !!item.dropdownElement
      });

      if (item.dropdownElement) {
        menuItems.push(item.dropdownElement);
      } else {
        menuItems.push(
          <NavLink
            tabIndex={-1}
            key={index}
            className={linkClassName}
            routeName={item.routeName}
            navParams={item.navParams}
            key={item.routeName}
          >
            {item.label}
            {item.notification && (
              <Notification
                isAuthroized={true}
                name={item.label}
                disabled={selected}
                onClick={item.notification.onClick}
                onMount={item.notification.onMount}
                onUnmount={item.notification.onUnmount}
              />
            )}
          </NavLink>
        );
      }
    });

    let className = 'secondary-navigation';
    if (this.props.className) {
      className += ` ${this.props.className}`;
    }
    return (
      <div style={style} className={className}>
        {this.props.title ? <div className="title">{this.props.title}</div> : null}
        <div className="navigation">{menuItems}</div>
      </div>
    );
  }
}

export default SecondaryNavigation;
